import moment from 'moment-timezone';

import { OnSite, OnSiteState } from './types';
import { ReduxAction, failure, pending, setAsyncData, success } from '../../core';

import { OnSiteActions } from './actions';

const initialState: OnSiteState = {
  onSites: { isFetching: false },
};

export function onSitesReducer(state: OnSiteState = initialState, action: ReduxAction<any>): OnSiteState {
  switch (action.type) {
    case pending(OnSiteActions.CREATE_ONSITE_EVENT):
    case OnSiteActions.SET_IS_FETCHING_ONSITE_EVENTS:
      return {
        ...state,
        onSites: setAsyncData(state.onSites, (v) => (v.isFetching = action.data)),
      };
    case OnSiteActions.SET_ONSITE_EVENTS_ERROR:
      return {
        ...state,
        onSites: setAsyncData(state.onSites, (v) => (v.error = action.data)),
      };
    case OnSiteActions.SET_ONSITE_EVENTS:
      return {
        ...state,
        onSites: setAsyncData(state.onSites, (v) => (v.data = action.data as OnSite[])),
      };
    case failure(OnSiteActions.CREATE_ONSITE_EVENT):
      return {
        ...state,
        onSites: setAsyncData(state.onSites, (v) => {
          v.error = action.data;
          v.isFetching = false;
        }),
      };
    case success(OnSiteActions.CREATE_ONSITE_EVENT):
      const onsiteList = state.onSites.data!.slice();
      if (moment(action.data.startTime).isBefore(moment(onsiteList[0].startDateTime))) {
        onsiteList.splice(0, 0, action.data);
      }
      for (let i = 0; i < onsiteList.length - 1; i++) {
        if (moment(action.data.startTime).isAfter(moment(onsiteList[i].startDateTime)) && moment(action.data.startTime).isBefore(moment(onsiteList[i + 1].startDateTime))) {
          onsiteList.splice(i + 1, 0, action.data);
          break;
        }
      }
      return {
        ...state,
        onSites: setAsyncData(state.onSites, (v) => {
          v.data = onsiteList;
          v.isFetching = false;
          v.error = '';
        }),
      };
    case OnSiteActions.UPDATE_ONSITE_EVENT:
      const editIndex = state.onSites.data!.findIndex((o) => o.onsiteId === action.data.onsiteId);
      const newOnSite = {
        ...state.onSites.data![editIndex],
        info: action.data.info,
        startTime: action.data.startTime,
        endTime: action.data.endTime,
        totalAppointments: action.data.totalAppointments,
        name: action.data.name,
        room: action.data.room,
        leadDoctorId: action.data.leadDoctorId,
      };
      return {
        ...state,
        onSites: setAsyncData(state.onSites, (v) => {
          v.data = v.data!.slice();
          v.data[editIndex] = newOnSite;
          v.isFetching = false;
          v.error = '';
        }),
      };
    case OnSiteActions.DELETE_ONSITE_EVENT:
      const index = state.onSites.data!.findIndex((o) => o.onsiteId === action.data);
      const newOnSitesWithDelete = state.onSites.data!.slice();
      newOnSitesWithDelete.splice(index, 1);
      return {
        ...state,
        onSites: setAsyncData(state.onSites, (v) => (v.data = newOnSitesWithDelete)),
      };
    case OnSiteActions.ONSITE_EMAIL_SENT:
      const emailIndex = state.onSites.data!.findIndex((o) => o.onsiteId === action.data.onSiteId);
      let newOnSite1: OnSite;
      if (action.data.isPromo) {
        newOnSite1 = {
          ...state.onSites.data![emailIndex],
          isPromoEmailSent: true,
        };
      } else if (action.data.isCashPay) {
        newOnSite1 = {
          ...state.onSites.data![emailIndex],
          isCashPayEmailSent: true,
        };
      } else {
        newOnSite1 = {
          ...state.onSites.data![emailIndex],
          isEmailSent: true,
        };
      }
      return {
        ...state,
        onSites: setAsyncData(state.onSites, (v) => {
          v.data = v.data!.slice();
          v.data[emailIndex] = newOnSite1;
        }),
      };
    default:
      return state;
  }
}
